var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsNotificationsIcon = function SvgDsNotificationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .667a5.74 5.74 0 0 0-3.943 1.55A5.21 5.21 0 0 0 2.406 6v3.322l-1.02 2.419a.667.667 0 0 0 .614.926h2.733a3.334 3.334 0 0 0 6.534 0H14a.667.667 0 0 0 .614-.926l-1.02-2.419V6a5.21 5.21 0 0 0-1.651-3.784A5.74 5.74 0 0 0 8 .666M4.974 3.184A4.4 4.4 0 0 1 8 2c1.141 0 2.23.43 3.026 1.184A3.88 3.88 0 0 1 12.26 6v3.332c0 .174.035.345.103.505l.631 1.496h-9.99l.63-1.496h.001q.102-.241.103-.505V6c0-1.049.44-2.063 1.235-2.816m4.912 9.483H6.114a2 2 0 0 0 3.772 0",
    clipRule: "evenodd"
  })));
};
export default SvgDsNotificationsIcon;